/*------------------------------------*\
    MODULES
\*------------------------------------*/
import videojs from "video.js";

/*------------------------------------*\
    VIDEO
\*------------------------------------*/
class Video {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        videojs(self.elem, {
            fluid: true
        });
    }
}

export default Video;
